import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

export const refrigerantNameField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Refrigerant name',
    context: 'The refrigerant gas name.',
  }),
  externalDescription: msg({
    message: 'The refrigerant gas name.',
    context: 'Refrigerant name',
  }),
};
